export const VOUCHER_CODE_MAX_LENGTH = 12;

export const SHIPTO_CART_REMINDER_FEATURE_FLAG = 'shipto-cart-reminder-enabled';

export const SHIPTO_RESTOCK_4_WEEKS_REMINDER_FEATURE_FLAG =
  'shipto-restock-4-weeks-reminder-enabled';

export const SHIPTO_WELCOME_REMINDER_FEATURE_FLAG =
  'shipto-welcome-reminder-enabled';
